/* Just Silver — keep the collection hero in step with the filters.

   The theme's facet form re-renders only the product-grid section over AJAX. The
   hero is a separate section, so applying a filter through the Filters panel left
   it stale: the count still said "95 pieces" while the grid showed 86, and the
   dismissible active-filter chips never appeared at all — they only rendered on a
   cold load of an already-filtered URL, which is not how anyone arrives.

   This re-fetches the hero through the Section Rendering API whenever the query
   string changes, so the count and the chips always describe what is on screen.
   Load More is ignored: it only advances `page`, and re-rendering the hero for
   that would be a wasted request.

   No theme file is patched. If this script fails to load, the hero simply behaves
   as it did before — correct on load, stale after filtering — rather than breaking.
*/
(() => {
  const HERO = '[data-coll-hero]';
  const IGNORED_PARAMS = ['page'];

  const meaningful = (search) => {
    const p = new URLSearchParams(search);
    IGNORED_PARAMS.forEach((k) => p.delete(k));
    p.sort();
    return p.toString();
  };

  let last = meaningful(window.location.search);
  let inflight = null;

  const refresh = async () => {
    const hero = document.querySelector(HERO);
    if (!hero) return;

    const next = meaningful(window.location.search);
    if (next === last) return;
    last = next;

    const id = hero.dataset.sectionId;
    if (!id) return;

    const params = new URLSearchParams(window.location.search);
    params.set('section_id', id);
    const url = `${window.location.pathname}?${params.toString()}`;

    inflight?.abort();
    inflight = new AbortController();

    try {
      const res = await fetch(url, { signal: inflight.signal });
      if (!res.ok) return;
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const fresh = doc.querySelector(HERO);
      if (fresh) document.querySelector(HERO).innerHTML = fresh.innerHTML;
    } catch (e) {
      if (e.name !== 'AbortError') console.error(e);
    }
  };

  // The theme navigates with history.replaceState, which fires no event of its
  // own, so wrap the two methods and emit one.
  const EVENT = 'js:collection-url-change';
  ['pushState', 'replaceState'].forEach((method) => {
    const original = history[method];
    if (original.__jsWrapped) return;
    const wrapped = function () {
      const result = original.apply(this, arguments);
      window.dispatchEvent(new Event(EVENT));
      return result;
    };
    wrapped.__jsWrapped = true;
    history[method] = wrapped;
  });

  window.addEventListener(EVENT, refresh);
  window.addEventListener('popstate', refresh);
})();
